import React from 'react';
 
class ABSDescriptionGap extends React.Component {
  render() { 
    return (
      <div style={{ width: 20, display: 'inline-block' }} />
    );
  }
}
 
export default ABSDescriptionGap;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDescriptionGap/index.tsx